export const setAttributes = (element, obj) => {
  Object.entries(obj).forEach(([attr, value]) => {
    element.setAttribute(attr, value)
  })
  return element
}

export const setupEventHandlers = (element, eventNames) => {
  eventNames.forEach(eventName => {
    element.addEventListener(eventName, element)
  })
}
